import { PropsWithChildren } from 'react';
import style from './FormBuilderContainer.module.css';

/**
 * Card wrapper for a block sitting alongside the form builder fields.
 * @param props - Component props.
 * @param props.children - The block to wrap.
 * @returns The wrapped block.
 */
export const FormBuilderContainer = ({ children }: PropsWithChildren) => {
  return <div className={style.container}>{children}</div>;
};
